// import React, { useState } from "react";

// // List Icon Component
// const ListIcon = ({ active }) => (
//   <svg xmlns="http://www.w3.org/2000/svg" width="14" height="10" viewBox="0 0 14 10" fill="none">
//     <path
//       fillRule="evenodd"
//       clipRule="evenodd"
//       d="M14 1.07998C14 0.82006 13.8946 0.570797 13.7071 0.387008C13.5196 0.203228 13.2652 0.0999756 13 0.0999756H0.999999C0.734799 0.0999756 0.4804 0.203228 0.2929 0.387008C0.1054 0.570797 0 0.82006 0 1.07998C0 1.33989 0.1054 1.58915 0.2929 1.77294C0.4804 1.95672 0.734799 2.05998 0.999999 2.05998H13C13.2652 2.05998 13.5196 1.95672 13.7071 1.77294C13.8946 1.58915 14 1.33989 14 1.07998ZM14 4.99998C14 4.74006 13.8946 4.4908 13.7071 4.30701C13.5196 4.12323 13.2652 4.01998 13 4.01998H0.999999C0.734799 4.01998 0.4804 4.12323 0.2929 4.30701C0.1054 4.4908 0 4.74006 0 4.99998C0 5.25989 0.1054 5.50916 0.2929 5.69294C0.4804 5.87672 0.734799 5.97998 0.999999 5.97998H13C13.2652 5.97998 13.5196 5.87672 13.7071 5.69294C13.8946 5.50916 14 5.25989 14 4.99998ZM14 8.91998C14 8.66008 13.8946 8.41077 13.7071 8.22702C13.5196 8.04327 13.2652 7.93998 13 7.93998H0.999999C0.734799 7.93998 0.4804 8.04327 0.2929 8.22702C0.1054 8.41077 0 8.66008 0 8.91998C0 9.17987 0.1054 9.42918 0.2929 9.61293C0.4804 9.79668 0.734799 9.89998 0.999999 9.89998H13C13.2652 9.89998 13.5196 9.79668 13.7071 9.61293C13.8946 9.42918 14 9.17987 14 8.91998Z"
//       fill={active ? "white" : "#868D96"}
//     />
//   </svg>
// );

// // Grid Icon Component
// const GridIcon = ({ active }) => (
//   <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none">
//     <path
//       d="M9.54545 0H12.0909C13.1453 0 14 0.854729 14 1.90909V4.45455C14 5.50891 13.1453 6.36364 12.0909 6.36364H9.54545C8.49109 6.36364 7.63636 5.50891 7.63636 4.45455V1.90909C7.63636 0.854729 8.49109 0 9.54545 0Z"
//       fill={active ? "white" : "#868D96"}
//     />
//     <path
//       d="M1.90909 0H4.45455C5.50891 0 6.36364 0.854729 6.36364 1.90909V4.45455C6.36364 5.50891 5.50891 6.36364 4.45455 6.36364H1.90909C0.854729 6.36364 0 5.50891 0 4.45455V1.90909C0 0.854729 0.854729 0 1.90909 0Z"
//       fill={active ? "white" : "#868D96"}
//     />
//     <path
//       d="M9.54545 7.63636H12.0909C13.1453 7.63636 14 8.49109 14 9.54545V12.0909C14 13.1453 13.1453 14 12.0909 14H9.54545C8.49109 14 7.63636 13.1453 7.63636 12.0909V9.54545C7.63636 8.49109 8.49109 7.63636 9.54545 7.63636Z"
//       fill={active ? "white" : "#868D96"}
//     />
//     <path
//       d="M1.90909 7.63636H4.45455C5.50891 7.63636 6.36364 8.49109 6.36364 9.54545V12.0909C6.36364 13.1453 5.50891 14 4.45455 14H1.90909C0.854729 14 0 13.1453 0 12.0909V9.54545C0 8.49109 0.854729 7.63636 1.90909 7.63636Z"
//       fill={active ? "white" : "#868D96"}
//     />
//   </svg>
// );

// // ToggleSwitch Component
// const ToggleSwitch = ({ onToggle, toggleState = true, className = "" }) => {
//   const [isToggled, setIsToggled] = useState(toggleState);

//   const handleToggle = () => {
//     setIsToggled((prev) => !prev);
//     if (onToggle) onToggle(!isToggled);
//   };

//   return (
//     <button
//       onClick={handleToggle}
//       className={`w-24 h-10 flex items-center rounded-md border overflow-hidden border-[rgba(81,80,80,0.2)] shadow-sm ${className}`}
//     >
//       <div
//         className={`flex w-1/2 h-full items-center justify-center transition-all duration-300 ${
//           isToggled ? "bg-[#505E70]" : "bg-white"
//         }`}
//       >
//         <ListIcon active={isToggled} />
//       </div>
//       <div
//         className={`flex w-1/2 h-full items-center justify-center transition-all duration-300 ${
//           !isToggled ? "bg-[#505E70]" : "bg-white"
//         }`}
//       >
//         <GridIcon active={!isToggled} />
//       </div>
//     </button>
//   );
// };

// export default ToggleSwitch;

import React, { useState } from "react";
import { ReactComponent as GridIcon } from "../../assets/images/icons/GridIcon.svg";
import { ReactComponent as ListIcon } from "../../assets/images/icons/ListIcon.svg";

const ToggleSwitch = ({ leftEle = <ListIcon />, rightEle = <GridIcon />, onToggle, toggleState = true, className }) => {
  const [isToggled, setIsToggled] = useState(toggleState);

  const handleToggle = () => {
    setIsToggled((prev) => !prev);
    if (onToggle) {
      onToggle(!isToggled);
    }
  };

  return (
    <button
      onClick={handleToggle}
      className={`w-32 h-10 flex items-center rounded-md border overflow-hidden border-[rgba(81, 80, 80, 0.20)] bg-white shadow-sm ${className}`}
    >
      <div
        className={`flex w-1/2 h-full items-center justify-center transition-all duration-300
           ${isToggled ? "bg-primary-active text-primary" : "text-primary-text"}
          `}
      >
        {leftEle}
      </div>
      <div
        className={`flex w-1/2 h-full items-center justify-center transition-all duration-300
          ${isToggled ? "text-primary-text" : "bg-primary-active text-primary"}
          `}
      >
        {rightEle}
      </div>
    </button>
  );
};

export default ToggleSwitch;
